var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankdetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(-20 -65)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(20 65)",
    fill: "#ff4100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "download_8_",
    "data-name": "download (8)",
    d: "M160.693,197.842h1.064a.421.421,0,0,1,.421.421v8.607a.421.421,0,0,1-.421.421h-1.064a.421.421,0,0,1-.421-.421v-8.607A.421.421,0,0,1,160.693,197.842ZM156.2,209.869H181.43a.421.421,0,0,1,.421.421v.764a.421.421,0,0,1-.421.421H156.2a.421.421,0,0,1-.421-.421v-.764A.421.421,0,0,1,156.2,209.869Zm2.339-2.093h20.55a.421.421,0,0,1,.421.421v.764a.421.421,0,0,1-.421.421h-20.55a.421.421,0,0,1-.421-.421V208.2A.421.421,0,0,1,158.541,207.777Zm10.43-18.363,12.614,5.038a.419.419,0,0,1-.154.808l-25.227,0a.421.421,0,0,1-.12-.824l12.579-5.024a.42.42,0,0,1,.309,0Zm-10.43,6.335h20.55a.421.421,0,0,1,.421.421v.764a.421.421,0,0,1-.421.421h-20.55a.421.421,0,0,1-.421-.421v-.764A.421.421,0,0,1,158.541,195.748Zm17.334,2.093h1.064a.421.421,0,0,1,.421.421v8.607a.421.421,0,0,1-.421.421h-1.064a.421.421,0,0,1-.421-.421v-8.607A.421.421,0,0,1,175.875,197.841Zm-5.06,0h1.064a.421.421,0,0,1,.421.421v8.607a.421.421,0,0,1-.421.421h-1.064a.421.421,0,0,1-.421-.421v-8.607A.421.421,0,0,1,170.815,197.841Zm-5.06,0h1.064a.421.421,0,0,1,.421.421v8.607a.421.421,0,0,1-.421.421h-1.064a.421.421,0,0,1-.421-.421v-8.607A.421.421,0,0,1,165.754,197.841Z",
    transform: "translate(-129.781 -117.384)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankdetails);
export default __webpack_public_path__ + "static/media/bankdetails.505b6a4d4b4e6cab5f1f3f14278609e7.svg";
export { ForwardRef as ReactComponent };